import { Report as ReportIcon } from '@mui/icons-material';
import React from 'react';

import { FlexBox, FlexBoxProps } from '../FlexBox/FlexBox';
import { Stack } from '../Stack/Stack';
import { Typography } from '../Typography/Typography';

export const ErrorIconBadge = ({
  text,
  invertColors,
  sx
}: {
  text: string;
  invertColors?: boolean;
  sx?: FlexBoxProps['sx'];
}) => {
  return (
    <FlexBox sx={sx}>
      <Stack
        direction={'row'}
        spacing={0.5}
        sx={(theme) => ({
          borderRadius: 3,
          bgcolor: invertColors ? theme.palette.error.contrastText : theme.palette.error.main,
          color: invertColors ? theme.palette.error.main : theme.palette.error.contrastText,
          alignItems: 'center',
          paddingX: 1,
          paddingY: 0.5
        })}>
        <ReportIcon />
        <Typography variant='body1Bold' text={text} />
      </Stack>
    </FlexBox>
  );
};
